var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "icon",
      attrs: {
        width: "20px",
        height: "20px",
        viewBox: "0 0 20 20",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    },
    [
      _c("title", [_vm._v("Instagram icon")]),
      _vm._v(" "),
      _c("defs", [
        _c("polygon", {
          attrs: {
            id: "path-1",
            points:
              "0 0.00622650376 19.7306156 0.00622650376 19.7306156 19.7344925 0 19.7344925"
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "g",
        {
          attrs: {
            id: "Archive",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd"
          }
        },
        [
          _c("g", { attrs: { id: "glyph-logo_May2016" } }, [
            _c("g", { attrs: { id: "Group-3" } }, [
              _c("mask", { attrs: { id: "mask-2", fill: "white" } }, [
                _c("use", { attrs: { "xlink:href": "#path-1" } })
              ]),
              _vm._v(" "),
              _c("g", { attrs: { id: "Clip-2" } }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M9.86532738,0.00622650376 C7.18605107,0.00622650376 6.85009398,0.0175830201 5.79785401,0.0655936717 C4.74780702,0.113486842 4.03066259,0.28027099 3.40315633,0.524161967 C2.75442513,0.776237469 2.20426065,1.11356516 1.65578008,1.66200658 C1.10733866,2.21048716 0.770010965,2.76065163 0.517935464,3.40938283 C0.274044486,4.0368891 0.107260338,4.75403352 0.0593671679,5.80408051 C0.0113565163,6.85632049 0,7.19227757 0,9.87155388 C0,12.550791 0.0113565163,12.8867481 0.0593671679,13.9389881 C0.107260338,14.9890351 0.274044486,15.7061795 0.517935464,16.3336858 C0.770010965,16.982417 1.10733866,17.5325815 1.65578008,18.081062 C2.20426065,18.6295034 2.75442513,18.9668311 3.40315633,19.2189458 C4.03066259,19.4627976 4.74780702,19.6295818 5.79785401,19.6774749 C6.85009398,19.7254856 7.18605107,19.7368421 9.86532738,19.7368421 C12.5445645,19.7368421 12.8805216,19.7254856 13.9327616,19.6774749 C14.9828086,19.6295818 15.699953,19.4627976 16.3274593,19.2189458 C16.9761905,18.9668311 17.5263549,18.6295034 18.0748355,18.081062 C18.6232769,17.5325815 18.9606046,16.982417 19.2127193,16.3336858 C19.4565711,15.7061795 19.6233553,14.9890351 19.6712484,13.9389881 C19.7192591,12.8867481 19.7306156,12.550791 19.7306156,9.87155388 C19.7306156,7.19227757 19.7192591,6.85632049 19.6712484,5.80408051 C19.6233553,4.75403352 19.4565711,4.0368891 19.2127193,3.40938283 C18.9606046,2.76065163 18.6232769,2.21048716 18.0748355,1.66200658 C17.5263549,1.11356516 16.9761905,0.776237469 16.3274593,0.524161967 C15.699953,0.28027099 14.9828086,0.113486842 13.9327616,0.0655936717 C12.8805216,0.0175830201 12.5445645,0.00622650376 9.86532738,0.00622650376 Z M9.86532738,1.78375627 C12.4994518,1.78375627 12.8114818,1.79382049 13.8517387,1.84128289 C14.8135965,1.88514254 15.3359571,2.04585683 15.683584,2.18096021 C16.1440711,2.35992325 16.4727052,2.57369987 16.8179041,2.91893797 C17.1631422,3.2641369 17.3769189,3.59277099 17.5558819,4.05325815 C17.6909853,4.40088503 17.8516996,4.92324561 17.8955592,5.88510338 C17.9430216,6.92536028 17.9530858,7.23739035 17.9530858,9.87155388 C17.9530858,12.5056783 17.9430216,12.8177083 17.8955592,13.8579652 C17.8516996,14.819823 17.6909853,15.3421836 17.5558819,15.6898105 C17.3769189,16.1502976 17.1631422,16.4789317 16.8179041,16.8241306 C16.4727052,17.1693687 16.1440711,17.3831454 15.683584,17.5621084 C15.3359571,17.6972118 14.8135965,17.8579261 13.8517387,17.9017857 C12.8116385,17.9492481 12.4996476,17.9593123 9.86532738,17.9593123 C7.23096805,17.9593123 6.91901629,17.9492481 5.87887688,17.9017857 C4.91701911,17.8579261 4.39465852,17.6972118 4.04703164,17.5621084 C3.58654449,17.3831454 3.2579104,17.1693687 2.91271147,16.8241306 C2.56751253,16.4789317 2.35369674,16.1502976 2.17473371,15.6898105 C2.03963033,15.3421836 1.87891604,14.819823 1.83505639,13.8579652 C1.78759398,12.8177083 1.77752976,12.5056783 1.77752976,9.87155388 C1.77752976,7.23739035 1.78759398,6.92536028 1.83505639,5.88510338 C1.87891604,4.92324561 2.03963033,4.40088503 2.17473371,4.05325815 C2.35369674,3.59277099 2.56747337,3.2641369 2.91271147,2.91893797 C3.2579104,2.57369987 3.58654449,2.35992325 4.04703164,2.18096021 C4.39465852,2.04585683 4.91701911,1.88514254 5.87887688,1.84128289 C6.91913377,1.79382049 7.23116385,1.78375627 9.86532738,1.78375627 L9.86532738,1.78375627 Z",
                  id: "Fill-1",
                  fill: "#0A0B09",
                  mask: "url(#mask-2)"
                }
              })
            ]),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M9.86532738,13.1599702 C8.0491463,13.1599702 6.57687187,11.6876958 6.57687187,9.87155388 C6.57687187,8.05537281 8.0491463,6.58309837 9.86532738,6.58309837 C11.6814693,6.58309837 13.1537437,8.05537281 13.1537437,9.87155388 C13.1537437,11.6876958 11.6814693,13.1599702 9.86532738,13.1599702 Z M9.86532738,4.80556861 C7.06743421,4.80556861 4.79934211,7.07366071 4.79934211,9.87155388 C4.79934211,12.6694079 7.06743421,14.9375 9.86532738,14.9375 C12.6631814,14.9375 14.9312735,12.6694079 14.9312735,9.87155388 C14.9312735,7.07366071 12.6631814,4.80556861 9.86532738,4.80556861 L9.86532738,4.80556861 Z",
                id: "Fill-4",
                fill: "#0A0B09"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M16.3152804,4.6054198 C16.3152804,5.25924185 15.7852444,5.78923872 15.1314223,5.78923872 C14.4776394,5.78923872 13.9476034,5.25924185 13.9476034,4.6054198 C13.9476034,3.95159774 14.4776394,3.42156172 15.1314223,3.42156172 C15.7852444,3.42156172 16.3152804,3.95159774 16.3152804,4.6054198",
                id: "Fill-5",
                fill: "#0A0B09"
              }
            })
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d9239a8", { render: render, staticRenderFns: staticRenderFns })
  }
}